import config from 'config';
import React from 'react';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {
	HeaderMenu,
	Navigation,
	RightSidebar,
	SignIn,
	SignUpForm,
	LostPasswordForm,
	ResetPassword,
	PassResetEmailNotification,
	ValidateEmailNotification
} from './';
import { validateTempHash } from 'api';
import * as Api from 'api';

import { fetch } from 'api';
import Globals from './globals';
import sockets from 'utils/sockets';
import * as Actions from 'actions';

import initTheme from '../theme';

import 'bootstrap-daterangepicker/daterangepicker.css';

// ********** EXTEND JQUERY ********* //
$.fn.animateBounce = function() {
	this.addClass('animated bounce');
	setTimeout(() => {
		this.removeClass('animated bounce');
	}, 1000);
}
// ********************************** //

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			validating_temp_hash : false,
			temp_hash_validated : false,
		}
	}

	componentWillMount() {
		Api.default({ url: config.url, url_v4: config.url_v4, version: 4 });
		this.props.updateUrl(config.url);
		this.props.updateBaseUrl(config.baseUrl);
		this.props.updateSocketClusterUrl(config.socketCluster);
		this.props.updateImagesPath('assets/images/');
    this.props.init();

    const {connection, routing, users} = this.props;
		let {pathname} = routing.locationBeforeTransitions;

    if(/^reset-password/.test(pathname) && !users.resetting_password) {
    	this.setState({validating_temp_hash : true})
    	let path_array = pathname.split('/')
			let id = path_array[path_array.length - 1]
			let hash = path_array[path_array.length - 2]
			Api.validateTempHash(id, hash)
			.then(val => {
				this.props.updateTmpUser({
					_id : id,
					temp_hash : hash
				});
				this.setState({
					validating_temp_hash : false,
					temp_hash_validated : true
				});
			})
			.catch((e) => {
				this.setState({validating_temp_hash : false})
				this.props.notify({message : e.message || e})
				this.props.push('/password-reset-request')
			})
    }
	}

	componentDidUpdate(prevProps, prevState) {
		// const {token} = this.props.connection;
		this.theme = new initTheme();
	}
  componentDidMount() {

  }
	render() {
		const {connection, routing, users} = this.props;
		let {pathname} = routing.locationBeforeTransitions;
		if(this.state.validating_temp_hash) {
			return (
				<div className="container-loader-spinner">
	        <i className="fa fa-spinner fa-spin fa-5x fa-fw"></i>
	        <br/>
	        <span className="loading-text">
	          Loading...
	        </span>
	      </div>
				)
		}

		if(!connection.logged_in) {
			if(this.props.users.fetching_temp_hash && pathname === 'password-reset-request') {
				return <PassResetEmailNotification />
			}
			else if(pathname == 'signup') {
				return <SignUpForm />
			}
			else if(pathname == 'password-reset-request') {
				return <LostPasswordForm />
			}
			else if(/^reset-password/.test(pathname) && this.state.temp_hash_validated) {
				return <ResetPassword />
			}
			else if(/^validate-account/.test(pathname)) {
				return <ValidateEmailNotification />
			}
			else {
				return <SignIn onSignin={e => {
					if(pathname == 'signin') {
						this.props.push('/');
					}
				}} />;
			}
		}
		else {
      window.Intercom("boot", {
        app_id: "av2dsfgy",
        name: connection.user && `${connection.user.name.first} ${connection.user.name.last}`,
        email: connection.user && connection.user.email,
        user_id: connection.user._id
      });
			return (
				<div>
					<HeaderMenu />
					<div className="inner-wrapper">
						<Navigation />
						{this.props.children}

					</div>
					{/* Add in global components here.*/}
					<Globals />
				</div>
			);
		}
	}
}

var mapStateToProps = ({connection, routing, users}) => ({connection, routing, users})

App.contextTypes = {
	router : PropTypes.object.isRequired
}

module.exports = connect(mapStateToProps,Actions)(App);



// WEBPACK FOOTER //
// ./src/browser/components/app.js